export async function getKanjiSuggestions(text: string) {
  if (!text.trim()) return [];

  try {
    const url = `https://www.google.com/transliterate?langpair=ja-Hira|ja&text=${encodeURIComponent(text)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch suggestions");

    const data = await response.json();

    // Flatten all suggestions from all segments
    // biome-ignore lint/suspicious/noExplicitAny: API returns complex nested array
    return data.flatMap((item: any) => item[1]) as string[];
  } catch (error) {
    console.error("Error fetching Kanji suggestions:", error);
    return [];
  }
}
